import {createContext} from 'react';

import {UserSessionContextProps} from 'pages/User/Conference/types';

export const UserSessionContext = createContext<UserSessionContextProps>({} as UserSessionContextProps);
